import React from 'react';
import cx from 'classnames';
import CircularProgress from '@material-ui/core/CircularProgress';

import styles from './styles/index.scss';
import { PropTypes } from 'helpers/react';
const { number, bool } = PropTypes;

class LoadingScreen extends React.Component {
  static propTypes = {
    topBarOffset: bool,
    appBarOffset: bool,
    sideBarOffset: bool,
    delay: number,
    transparent: bool
  };

  static defaultProps = {
    delay: 2000
  };

  state = {
    delayPassed: !this.props.delay // synchronous for delay={ 0 }
  };

  mounted = false; // eslint-disable-line

  UNSAFE_componentWillMount() {
    this.mounted = true;

    setTimeout(
      () => this.mounted && this.setState({ delayPassed: true }),
      this.props.delay
    );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    const containerClasses = cx(styles['loading-screen'], {
      [styles['has-sidebar-offset']]: this.props.sideBarOffset,
      [styles['has-topbar-offset']]: this.props.topBarOffset,
      [styles['has-appBar-offset']]: this.props.appBarOffset,
      [styles['has-both-offsets']]:
        this.props.appBarOffset && this.props.topBarOffset
    });

    return (
      <div
        className={`${containerClasses} ${this.props.transparent
          ? styles['transparent']
          : ''}`}
      >
        {this.state.delayPassed && <CircularProgress size={80} thickness={3} />}
      </div>
    );
  }
}

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/client/shared-components/LoadingScreen/index.js